var __decorate=this&&this.__decorate||function(e,r,n,a){var o,t=arguments.length,i=t<3?r:null===a?a=Object.getOwnPropertyDescriptor(r,n):a;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)i=Reflect.decorate(e,r,n,a);else for(var l=e.length-1;l>=0;l--)(o=e[l])&&(i=(t<3?o(i):t>3?o(r,n,i):o(r,n))||i);return t>3&&i&&Object.defineProperty(r,n,i),i};import{css as e,html as r,unsafeCSS as n}from"lit";import{OrElement as a}from"@openremote/or-element";import{customElement as o,property as t,query as i}from"lit/decorators.js";import{DefaultColor2 as l,DefaultColor3 as d}from"@openremote/core";import{when as p}from"lit/directives/when.js";let style=e`
  :host {
    --internal-or-panel-background-color: var(
      --or-panel-background-color,
      var(--or-app-color2, ${n(l)})
    );
    --internal-or-panel-padding: var(--or-panel-padding, 10px);
    --internal-or-panel-border: var(--or-panel-border, 1px solid #e5e5e5);
    --internal-or-panel-border-radius: var(--or-panel-border-radius, 5px);
    --internal-or-panel-heading-margin: var(--or-panel-heading-margin, 0 0 10px 7px);
    --internal-or-panel-heading-min-height: var(--or-panel-heading-min-height, 36px);
    --internal-or-panel-heading-color: var(--or-panel-heading-color, var(--or-app-color3, ${n(d)}));
    --internal-or-panel-heading-font-size: var(--or-panel-heading-font-size, larger);
    --internal-or-panel-heading-font-weight: var(--or-panel-heading-font-weight, bolder);
    --internal-or-panel-heading-text-transform: var(--or-panel-heading-text-transform, unset);
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  #wrapper {
    height: 100%;
    flex: 1;
  }

  #panel {
    padding: var(--internal-or-panel-padding);
    background-color: var(--internal-or-panel-background-color);
    border: var(--internal-or-panel-border);
    border-radius: var(--internal-or-panel-border-radius);
  }

  #heading {
    display: flex;
    align-items: center;
    margin: var(--internal-or-panel-heading-margin);
    min-height: var(--internal-or-panel-heading-min-height);
    font-size: var(--internal-or-panel-heading-font-size);
    font-weight: var(--internal-or-panel-heading-font-weight);
    color: var(--internal-or-panel-heading-color);
    text-transform: var(--internal-or-panel-heading-text-transform);
  }
`,OrPanel=class extends a{static get styles(){return[style]}render(){return r`
      <div id="wrapper">
        <div id="panel">
          ${this.heading?r`
                  ${p("string"!=typeof this.heading,()=>r` ${this.heading} `,()=>r`
                      <div id="heading">
                        <span>${this.heading}</span>
                      </div>
                    `)}
                `:""}
          <slot></slot>
        </div>
      </div>
    `}};__decorate([t({type:Number})],OrPanel.prototype,"zLevel",void 0),__decorate([t({type:String})],OrPanel.prototype,"heading",void 0),__decorate([i("#panel")],OrPanel.prototype,"_panel",void 0),OrPanel=__decorate([o("or-panel")],OrPanel);export{OrPanel};